import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {  MatSnackBarModule } from '@angular/material/snack-bar';
import { QuizComponent } from './quiz.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AllMocksModule } from '../all-mocks/all-mocks.module';
import { CommonChildComponentsModule } from '../components/common-components.module'
export const routes:any[] = [
  {
    path: '', component: QuizComponent
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ChildComponentsModule,
    CommonChildComponentsModule,
ComponentsModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatExpansionModule,
    NgxSpinnerModule,
    MatTooltipModule,
    AllMocksModule
  ],
  declarations: [
    QuizComponent
  ],


})
export class QuizModule { }